import { createTheme } from '@mui/material'
import { ThemeOptions as V4ThemeOptions } from '@material-ui/core'

/**
 * Builds the v5 theme from the v4 one the app already has, so the two libraries
 * cannot disagree about the brand colours. The v4 theme comes from the shared
 * frontend package, which admin and client also consume, so it is read here
 * rather than changed there.
 */
export function createV5Theme(v4Theme: V4ThemeOptions) {
  const palette = v4Theme.palette ?? {}
  const channel = (c?: { main?: string; contrastText?: string }) =>
    c?.main
      ? { main: c.main, ...(c.contrastText ? { contrastText: c.contrastText } : {}) }
      : undefined

  return createTheme({
    palette: {
      // v4 calls it `type`, v5 calls it `mode`.
      mode: palette.type ?? 'light',
      primary: channel(palette.primary as never),
      secondary: channel(palette.secondary as never),
      error: channel(palette.error as never),
      warning: channel(palette.warning as never),
      info: channel(palette.info as never),
      success: channel(palette.success as never),
      background: palette.background,
    },
    // Matches the v4 theme's control styling; the two libraries each style their
    // own components, so neither one reaches the other's.
    shape: { borderRadius: 8 },
    typography: {
      button: { textTransform: 'none', letterSpacing: 0, fontWeight: 600 },
    },
    components: {
      MuiButton: { defaultProps: { disableElevation: true } },
      MuiTab: { styleOverrides: { root: { textTransform: 'none' } } },
    },
  })
}
